import {type SvgProps, type NumberProp} from 'react-native-svg';
import {getDescriber} from '../../../screens/descriptor/DescriptorType';

export function MemberTierIcon({
  size,
  ...props
}: SvgProps & {size?: NumberProp}) {
  return getDescriber()?.getMemberTier(size, props);
}
